import { render, staticRenderFns } from "./PostStartPage.vue?vue&type=template&id=396d2394"
import script from "./PostStartPage.vue?vue&type=script&lang=js"
export * from "./PostStartPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports